/* eslint-disable react/no-unknown-property */
import React from 'react';
import { ListItem, SelectList } from '@tencent/workbench';
import { getFontFamilyConfigData } from '@src/framework/editor/src/js/constants/toolbar-data';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { IQuickToolFontList, QuickToolFontListProps } from '../core/quick-tool-dialog-manager.interface';

const QuickToolFontList: IQuickToolFontList = (props: QuickToolFontListProps) => {
    const fontFamilyList: ListItem[] = getFontFamilyConfigData();
    const { onFontChange, selectedFontFamily, FontListModule } = props;

    const getFontList = () => {
        const itemListWithStyle: ListItem[] = fontFamilyList.map(item => ({
            ...item,
            style: {
                fontFamily: item.id,
            },
        }));
        const showCloudFont = appConfigInstance.getConfig(ToolbarFileMenuConfig.cloudFont as any) ?? true;
        const disableCustomFont = !showCloudFont;  // 使用cac即可
        if (disableCustomFont) {
            return <SelectList
                style={{ width: '100%' }}
                items={itemListWithStyle}
                onChange={onFontChange}
                className="select-list-font-family"
            />;
        }
        // c 端使用云字体列表
        return (
            // b 端构建问题，需要 ignore 这里
            // @ts-ignore
            <FontListModule
                defaultFonts={itemListWithStyle}
                selectedFontFamily={selectedFontFamily}
                onFontChange={onFontChange}
            />
        );
    };
    return (
        getFontList()
    );
};

export default QuickToolFontList;
